// RP Change 6-17-2026 script for applying box shadow in bottom of header when not in default position and when is scrolled
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.site-header');

  window.addEventListener('scroll', () => {
    header.classList.toggle('is-scrolled', window.scrollY > 0);
  });
});

// RP Change 6-18-2026 for making submenu of header close when it is clicked
document.querySelectorAll('[data-header-dropdown] a').forEach(link => {
  link.addEventListener('click', () => {
    document.body.click();
  });
});

// RP Change 7-6-2026 for making submenu of header close when it is clicked in mobile
document.addEventListener('click', function (e) {
  const link = e.target.closest('.sidebar-nav a');
  if (!link) return;

  Alpine.store('modals').close('nav');
}, true);


// RP Change 7-9-2026 for making share fb work in iOS (single product page and single blog post page)
document.addEventListener('click', async (event) => {

  const facebookShare = event.target.closest('a.ccb-fb-share-button');
  if (!facebookShare) return;

  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

  if (!isIOS) return; // Android/Desktop keeps normal href behavior

  // Stop the normal Facebook sharer URL on iOS
  event.preventDefault();

  const url = facebookShare.dataset.shareUrl || window.location.href;

  if (navigator.share) {
    try {
      await navigator.share({
        // title: document.title,
        // text: document.querySelector('meta[property="og:description"]')?.content || '',
        url: url
      });
    } catch (error) {
      // User cancelled share sheet
      console.log('Share cancelled', error);
    }
  } else {
    // fallback if iOS browser does not support Web Share
    window.open(
      facebookShare.href,
      '_blank'
    );
  }
});
